module.exports = __webpack_public_path__ + "media/warning2.234fd1e4.wav";